module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/oleksandr-zozulinskiy-avatar-4f2517fbe40d38d7dcb2a9c8ffd34365.jpg";